import { ToastrService } from "ngx-toastr";
import { InitialLoadAction } from "./initial-load-action"
import { Injectable } from "@angular/core";
import { Permission } from "@nucleus/user-ui";
import { ApplicationConfigService } from "../application-config.service";
import { PermissionsService } from "../permission/permissions.service";
import { PermissionCheckerService } from "../permission/permission-checker.service";
import { LoadingService } from "./loading-service";


@Injectable({
    providedIn: 'root'
  })
export class InitPermissionsAction extends InitialLoadAction<boolean> {

    constructor(loadingService : LoadingService,
        private permissionService : PermissionsService,
        private permissionChecker : PermissionCheckerService,
        private configService : ApplicationConfigService,
        private toastrService: ToastrService) {
        super('Permissions', loadingService);
    }

    override onLoad(): Promise<boolean> {
        // The permission catalog (the full capability vocabulary) is consumed ONLY
        // by the admin role-tree / group-editor screens (through BookwiseAppConfigAdapter),
        // which only Admins and Auditors can open. The server therefore gates
        // GET /v1/permissions on user/role/group management authorities, so a plain
        // client or accountant 403s on it. Skip the fetch for everyone who can't use
        // it — no wasted call, and no bootstrap 403 noise for regular users.
        // TODO NUC-269: this is a bootstrap fetch-optimization keyed on the two
        // personas that can open the catalog screens, not a screen access gate.
        // A precise capability mapping (the server's user/role/group management
        // authorities) spans several caps; left role-based to keep the skip broad.
        if (!this.permissionChecker.hasRoleAdmin() && !this.permissionChecker.hasRoleAuditor()) {
            return Promise.resolve(true);
        }

        return new Promise<boolean>(
            (resolve, reject) => {
                this.permissionService.search({ 
                    onStart: () => {},
                    onSuccess: (permissions: Permission[]) => this.configService.setPermissions(permissions),
                    onError: (error: any) => this.toastrService.error(error?.message || error?.toString() || 'Failed to load permissions'),
                    onComplete: () => {resolve(true)}}
                );
            }
        );

    }
}